// extracted by mini-css-extract-plugin
export var compact = "_pq-2";
export var phoneFrame = "_pq-0";
export var phoneScreen = "_pq-1";